module.exports = {
	init: function ($el, $) {
		const $customButtons = $el.find('.custom-btn');
		const buttonConfigs = $.widget.buttons || [];

		if ($customButtons.length !== buttonConfigs.length) {
			console.error(
				`Mismatch between the number of buttons found (${$customButtons.length}) and the number of buttons configured (${buttonConfigs.length}). Removing all the custom buttons.`
			);
			$customButtons.remove();
		} else {
			// setup the onclick listeners
			$customButtons.each(function (idx) {
				const $btn = jQuery(this);
				const config = buttonConfigs[idx] || {};
				if (config.on) {
					Object.keys(config.on).forEach(key => {
						const pointer = config.on[key];
						const handler = $.widget[pointer];
						if (handler) {
							$btn.on(key, e => {
								handler(e, $btn, $);
							});
						} else {
							console.error(`Invalid handler key provided: ${rootKey}`);
						}
					});
				}
			});
		}
	},
};
